import { useClickAway } from '@uidotdev/usehooks';
import { BrushSquare } from 'iconsax-react';
import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

interface IProps {
  inputValue: {
    speaker: string;
    main_color: string;
    sub_color: string;
    KO: string;
    EN: string;
    JA: string;
    AR: string;
    ID: string;
    ES: string;
    MS: string;
    RU: string;
    ZH: string;
    SC: string;
  };
  setInputValue: React.Dispatch<
    React.SetStateAction<{
      speaker: string;
      main_color: string;
      sub_color: string;
      KO: string;
      EN: string;
      JA: string;
      AR: string;
      ID: string;
      ES: string;
      MS: string;
      RU: string;
      ZH: string;
      SC: string;
    }>
  >;
  type: string;
}
const ColorPicker: React.FC<IProps> = ({ inputValue, setInputValue, type }) => {
  const [isActive, setIsActive] = useState<boolean>(false);

  const handleOnChange = (color) => {
    const cloneData = JSON.parse(JSON.stringify(inputValue));
    cloneData[type] = color.hex;
    setInputValue(cloneData);
  };

  const ref = useClickAway(() => {
    setIsActive(false);
  });
  return (
    <Wrapper>
      <ColorInput
        color={inputValue[type]}
        onClick={() => {
          if (!isActive) {
            setIsActive(true);
          }
        }}
      >
        <div className='color-section'>
          <div className='colorBox'></div>
          <p>{inputValue[type]}</p>
        </div>
        <BrushSquare size='32' color={inputValue[type]} variant='Bold' />
      </ColorInput>
      {isActive && (
        <ColorPickerWrapper ref={ref}>
          <SketchPicker
            color={inputValue[type]}
            onChangeComplete={handleOnChange}
          />
        </ColorPickerWrapper>
      )}
    </Wrapper>
  );
};

export default ColorPicker;

const Wrapper = styled.div`
  position: relative;
`;

const ColorPickerWrapper = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
`;

const ColorInput = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border: 1px solid ${theme.colors.gray_5};
  border-radius: 0.4rem;
  padding: 4px;
  width: 100%;
  &:hover {
    border: 1px solid #4096ff;
  }
  .colorBox {
    border-radius: 6px;
    width: 32px;
    height: 32px;
    background-color: ${(props) => props.color};
  }
  .color-section {
    display: flex;
    justify-content: center;
    align-items: center;
    & > * + * {
      margin-left: 8px;
    }
    p {
      font-size: ${theme.fontSizes.normal};
      font-weight: ${theme.fontWeights.medium};
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_400};
    }
  }
`;
